import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';
import { createStyles, Theme } from '@material-ui/core/styles';
import styled from '@material-ui/core/styles/styled';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';
import Rating from '../Rating/Rating';

const useStyles = makeStyles(() =>
  createStyles({
    ratingWrapper: {
      marginBottom: 0,
      alignItems: 'flex-start',
    },
  }),
);

const ReviewMessage = ({ text, name, date, rating = 0 }) => {
  const classes = useStyles();
  return (
    <Wrapper data-testid="reviewMessageItem">
      <Row>
        <div>
          <UserName data-testid="reviewName">{name}</UserName>
          <Date data-testid="reviewDate">{date}</Date>
        </div>
        <Rating name="reviewItem" hideValue wrapperClass={classes.ratingWrapper} value={rating} />
      </Row>
      <Message data-testid="reviewMessage">{text}</Message>
    </Wrapper>
  );
};

export default ReviewMessage;

const Message = styled('div')(({ theme }: { theme: Theme }) => ({
  color: colorsPalette.gray,
  fontSize: 16,
  whiteSpace: 'pre-wrap',
  [theme.breakpoints.up('md')]: {
    fontSize: 18,
  },
}));
const Date = styled(Typography)({
  fontSize: 14,
});
const UserName = styled(Typography)({
  fontSize: 18,
});
const Wrapper = styled('div')({
  marginBottom: MIDDLE_MARGIN,
  '&:not(:last-child)': {
    paddingBottom: MIDDLE_MARGIN,
    borderBottom: `1px solid ${colorsPalette.violetAnalyticsCard}`,
  },
});
const Row = styled('div')(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  marginBottom: SMALL_MARGIN,
  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-start',
  },
}));
